// Weather + temperature helpers.

export function fToC(f) {
  if (typeof f !== "number") return null;
  return Math.round((f - 32) * 5 / 9);
}

export function isUS(region) {
  return (region?.code || "").toUpperCase() === "US";
}

/**
 * Returns { high, low, unit } for display, converted based on region.
 * US -> °F, everyone else -> °C.
 */
export function displayTemp(weather, region) {
  const hiF = weather?.high_f;
  const loF = weather?.low_f;
  if (isUS(region)) {
    return { high: hiF ?? "--", low: loF ?? "--", unit: "F" };
  }
  return {
    high: fToC(hiF) ?? "--",
    low: fToC(loF) ?? "--",
    unit: "C",
  };
}
